import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  FacebookContentTemplateCreateParams,
  createFacebookContentTemplate,
  deleteFacebookContentTemplate,
  listFacebookContentTemplates,
} from '~/services/PublicOfferFeedService';

export const facebookContentTemplatesQueryKeys = {
  all: ['facebookContentTemplates'] as const,
  lists: () => [...facebookContentTemplatesQueryKeys.all, 'list'] as const,
  list: () => [...facebookContentTemplatesQueryKeys.lists()] as const,
};

export function useGetFacebookContentTemplates() {
  return useQuery({
    queryKey: facebookContentTemplatesQueryKeys.list(),
    queryFn: async ({ signal }) => {
      return await listFacebookContentTemplates();
    },
    refetchOnWindowFocus: true,
  });
}

export function useCreateFacebookContentTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: FacebookContentTemplateCreateParams) => {
      return await createFacebookContentTemplate(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facebookContentTemplatesQueryKeys.all });
    },
  });
}

export function useDeleteFacebookContentTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      return await deleteFacebookContentTemplate(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facebookContentTemplatesQueryKeys.all });
    },
  });
}
